import React from "react";
import { Row, Col } from "react-bootstrap";

export default function MerchCard({ merchBody }) {
  const handleClick = (input) => {
    window.open(input, "_blank")
  };
  return (
    <Col className="merch-card" onClick={() => handleClick(merchBody.link)}>
      <Row className="merch-card-img">
        <img src={merchBody.img} alt={`Toronto Boxing ${merchBody.name}`} />
      </Row>
      <Row className="merch-card-body">
        <div className="merch-card-body-name">{merchBody.name}</div>
        <div className="merch-card-body-price">{merchBody.price}</div>
        <Col>
          <button alt="Buy Now Button" className="btn btn-secondary merch-card-buy-btn">
            Buy Now
          </button>
        </Col>
      </Row>
    </Col>
  );
}
